import React from 'react';
import { AlertCircle, CheckCircle, XCircle, Phone, Mail } from 'lucide-react';
const CancellationPolicy = () => {
  return <div className="w-full" data-id="element-211">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-212">
        <div className="container mx-auto px-4" data-id="element-213">
          <div className="max-w-3xl mx-auto text-center" data-id="element-214">
            <h1 className="text-4xl font-bold mb-6" data-id="element-215">Cancellation Policy</h1>
            <p className="text-xl" data-id="element-216">
              Information about our cancellation terms and procedures
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-217">
        <div className="container mx-auto px-4" data-id="element-218">
          <div className="max-w-3xl mx-auto" data-id="element-219">
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-220">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-221">
                Cancellation Policy & Exclusions
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-222">
                At Peakwave, your satisfaction with our service plans is our
                priority. We understand that circumstances can change, so we
                offer a simple and transparent cancellation process to give you
                peace of mind.
              </p>
              <div className="space-y-8" data-id="element-223">
                <div className="border-l-4 border-green-500 pl-4" data-id="element-224">
                  <h3 className="text-xl font-semibold text-[#0a2e4a] mb-3" data-id="element-225">
                    Cancellation Within 14 Days
                  </h3>
                  <p className="text-gray-600" data-id="element-226">
                    You have the right to cancel your service plan within 14
                    days of purchase. If you cancel within this period, you'll
                    receive a full refund—no questions asked. This cooling-off
                    period lets you review your plan to ensure it meets your
                    needs.
                  </p>
                </div>
                <div className="border-l-4 border-yellow-500 pl-4" data-id="element-227">
                  <h3 className="text-xl font-semibold text-[#0a2e4a] mb-3" data-id="element-228">
                    Cancellation After 14 Days and Within 28 Days
                  </h3>
                  <p className="text-gray-600" data-id="element-229">
                    If you decide to cancel after the initial 14-day period but
                    within 28 days from purchase, you may be eligible for a
                    partial refund. This refund is granted at Peakwave's
                    discretion, considering any services or repairs already
                    provided under your plan.
                  </p>
                </div>
                <div className="border-l-4 border-red-500 pl-4" data-id="element-230">
                  <h3 className="text-xl font-semibold text-[#0a2e4a] mb-3" data-id="element-231">
                    No Cancellations or Refunds After 28 Days
                  </h3>
                  <p className="text-gray-600" data-id="element-232">
                    Cancellations and refunds cannot be processed after 28 days
                    from the purchase date. Please review your plan carefully
                    and contact us promptly if you have any concerns or need
                    assistance.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-233">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-234">
                How to Cancel Your Service Plan
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-235">
                To cancel your plan, please contact our customer support team
                using the following:
              </p>
              <div className="space-y-4 mb-6" data-id="element-236">
                <div className="flex items-center" data-id="element-237">
                  <Phone className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-238" />
                  <span className="text-gray-600" data-id="element-239">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-240">
                      0800 055 4969
                    </a>
                  </span>
                </div>
                <div className="flex items-center" data-id="element-241">
                  <Mail className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-242" />
                  <span className="text-gray-600" data-id="element-243">
                    Email:{' '}
                    <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-244">
                      sunitalimbu9596@gmail.com
                    </a>
                  </span>
                </div>
              </div>
              <p className="text-gray-600" data-id="element-245">
                Once we receive your cancellation request, we'll review your
                case promptly. If eligible, your refund will be processed
                quickly, and you'll receive confirmation when your cancellation
                and refund are complete.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-246">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-247">
                Refund Processing
              </h2>
              <p className="text-gray-600" data-id="element-248">
                All refunds are made to the original payment method used at
                purchase. For security reasons, we don't process refunds to
                alternative accounts or payment methods.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-249">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-250">
                Plan Exclusions and Coverage Limits
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-251">
                To maintain fairness and service quality, the following are
                excluded from coverage under your Peakwave plan:
              </p>
              <div className="space-y-4 mb-6" data-id="element-252">
                <div className="flex items-start" data-id="element-253">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-254" />
                  <span className="text-gray-600" data-id="element-255">
                    <strong data-id="element-256">Pre-existing Faults:</strong> Faults or damage
                    present before your plan started are not covered.
                  </span>
                </div>
                <div className="flex items-start" data-id="element-257">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-258" />
                  <span className="text-gray-600" data-id="element-259">
                    <strong data-id="element-260">Misuse or Neglect:</strong> Damage caused by
                    improper use, neglect, accidents, or unauthorized repairs is
                    excluded.
                  </span>
                </div>
                <div className="flex items-start" data-id="element-261">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-262" />
                  <span className="text-gray-600" data-id="element-263">
                    <strong data-id="element-264">Non-standard Repairs:</strong> Repairs beyond normal
                    appliance operation or servicing, including modifications or
                    alterations, are excluded.
                  </span>
                </div>
                <div className="flex items-start" data-id="element-265">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-266" />
                  <span className="text-gray-600" data-id="element-267">
                    <strong data-id="element-268">Illegal or Fraudulent Use:</strong> Any fraudulent
                    or illegal use of our services will result in immediate plan
                    cancellation without refund.
                  </span>
                </div>
                <div className="flex items-start" data-id="element-269">
                  <XCircle className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-270" />
                  <span className="text-gray-600" data-id="element-271">
                    <strong data-id="element-272">Manufacturer's Guidelines:</strong> Appliances not
                    used or maintained as per manufacturer instructions are
                    excluded.
                  </span>
                </div>
              </div>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-273">
                <div className="flex items-start" data-id="element-274">
                  <AlertCircle className="text-yellow-500 mr-3 flex-shrink-0" size={20} data-id="element-275" />
                  <p className="text-sm text-gray-600" data-id="element-276">
                    If any of these exclusions apply, your plan may be voided
                    immediately, and you'll lose eligibility for repairs or
                    refunds under the plan.
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-12 bg-[#e6f4fa] p-8 rounded-lg" data-id="element-277">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-278">
                Need Help?
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-279">
                If you have any questions about cancelling your plan or want
                clarification on coverage, please contact our customer service
                team. We're here to support you and ensure you understand your
                options clearly.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-280">
                <a href="tel:08000554969" className="bg-[#0a2e4a] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-[#164875] transition flex items-center justify-center" data-id="element-281">
                  <Phone size={18} className="mr-2" data-id="element-282" /> Call: 0800 055 4969
                </a>
                <a href="/contact" className="bg-[#f05a28] text-white px-6 py-3 rounded-md font-semibold text-center hover:bg-[#d94e20] transition flex items-center justify-center" data-id="element-283">
                  <Mail size={18} className="mr-2" data-id="element-284" /> Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default CancellationPolicy;